import { useEffect } from "react";
import FormCreator from "../../../components/forms/FormCreator";
import Label from "../../../components/forms/ui/label/Label";
import Buttons from "../../../components/ui/button/Buttons";
import { useState } from "react";
import { useRef } from "react";
import { useAddEventGalleryImageMutation, useDeleteImageByeventGallaryIdMutation, useGetEventGalleryDetailsByeventGallaryIdQuery, useLazyGetEventGalleryDetailByIdQuery, useLazyGetEventGalleryImagesQuery, useUpdateEventGalleryDetailsMutation } from "../../../app/services/EventGallery/EventGalleryApi";
import { EditEventGalleryFormData } from "../data/EditEventGalleryForm.Data";
import { useLazyGetAllDropDownForEventManagementQuery } from "../../../app/services/EventManagement/EventManagementApi";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { useNavigate, useParams } from "react-router-dom";
import SwalAlert from "../../../services/swalService/SwalService";
import DataLoader from "../../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { API_URL } from "../../../utils/API/fetchBaseQuery";
import Iconify from "../../../components/ui/iconify/Iconify";
import { EditUploadImageFormData } from "../data/EditUploadImageForm.Data";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EditEventGalleryForm = () => {
    const editEventGalleryRef = useRef();
    const uploadImgRef = useRef();
    const { id } = useParams()
    const navigate = useNavigate();
    const { success, error, confirm } = SwalAlert();
    const audit = getAuditContext();
    const [Editform, setEditForm] = useState(EditEventGalleryFormData);
    const [EditUploadImageform, setEditUploadImageForm] = useState(EditUploadImageFormData);
    const [galleryEventImageList, setGalleryEventImageList] = useState();
    const [deletedImageId, setDeletedImageId] = useState(null);

    const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();
    const [getEventGalleryByid, { isSuccess: isSuccessEventGalleryById, isFetching: isFetchingEventGalleryById, data: eventGalleryByIdResponse }] = useLazyGetEventGalleryDetailByIdQuery();
    const [updateEventGalleryDetails, { isSuccess: isSuccessUpdateEventGallery, isFetching: isFetchingUpdateEventGallery, data: updateEventGalleryResponse }] = useUpdateEventGalleryDetailsMutation()
    const [getEventGalleryImages, { isLoading: isLoadinggetEventGalleryImages, data: GetEventGalleryImagesResponse, isSuccess: isSuccessGetEventGalleryImages }] = useLazyGetEventGalleryImagesQuery();
    const [deleteEventGalleryById, { isSuccess: isSuccessDeleteImageByeventGallaryId, data: DeleteImageByeventGallaryIdResponse }] = useDeleteImageByeventGallaryIdMutation();
    const [uploadImage, { isSuccess: uploadImageSuccess, isLoading: uploadImageLoading, data: uploadImageResponse }] = useAddEventGalleryImageMutation();

    const viewListDropDowns = [
        { dropdownName: "Gallery Event Type", fieldId: "eventType" },
        { dropdownName: "Gallery Event Topic Drp", fieldId: "eventTopic" },
    ];

    useEffect(() => {
        if (id) {
            getEventGalleryByid(id);
            geEventListDropDown();
            getEventGalleryImages(id)
        }
    }, [id])

    useEffect(() => {
        if (!uploadImageLoading && uploadImageSuccess && uploadImageResponse) {
            getEventGalleryImages(id)
            success("Image has been uploaded successfully");
        }
    }, [uploadImageLoading, uploadImageSuccess, uploadImageResponse]);

    // Effect for set dropdown
    useEffect(() => {
        if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
            // Updates dropdown fields in the form based on the fetched data
            setAllDropDownFieldsBatch(EditEventGalleryFormData, viewListDropDowns, viewEventListDropDownData);
        }
    }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);

    useEffect(() => {
        if (!isFetchingUpdateEventGallery && isSuccessUpdateEventGallery && updateEventGalleryResponse) {
            if (updateEventGalleryResponse.hasError === false) {
                success("Event Gallery has been updated successfully");
                handleBack();
            }
            else {
                error(updateEventGalleryResponse.errorMessage)
            }
        }
    }, [isFetchingUpdateEventGallery, isSuccessUpdateEventGallery, updateEventGalleryResponse]);

    useEffect(() => {
        if (!isFetchingEventGalleryById && isSuccessEventGalleryById && eventGalleryByIdResponse) {
            EditEventGalleryFormData.initialState.eventName = eventGalleryByIdResponse?.eventName;
            EditEventGalleryFormData.initialState.eventDate = eventGalleryByIdResponse?.eventDate;
            EditEventGalleryFormData.initialState.eventType = eventGalleryByIdResponse?.eventType;
            // EditEventGalleryFormData.initialState.eventTopic = eventGalleryByIdResponse?.eventTopicId;
            EditEventGalleryFormData.initialState.eventTopic = eventGalleryByIdResponse?.eventTopicId ? eventGalleryByIdResponse.eventTopicId.split(",").map(id => Number(id.trim())) : null;
            EditEventGalleryFormData.initialState.isPublished = eventGalleryByIdResponse?.isPublish;
            EditEventGalleryFormData.initialState.isPrivate = eventGalleryByIdResponse?.isPrivate;
        }
    }, [isFetchingEventGalleryById, isSuccessEventGalleryById, eventGalleryByIdResponse]);

    useEffect(() => {
        if (!isLoadinggetEventGalleryImages && isSuccessGetEventGalleryImages && GetEventGalleryImagesResponse) {
            let galleryEventImageList = GetEventGalleryImagesResponse?.map((obj) => ({
                GalleryEventImageId: obj?.galleryEventImageId,
                imageEncriptedName: `${API_URL}/Common/getImage?fileName=${obj.imageEncriptedName}`
            }));
            setGalleryEventImageList(galleryEventImageList);
            // console.log({ galleryEventImageList })
        }
    }, [isLoadinggetEventGalleryImages, isSuccessGetEventGalleryImages, GetEventGalleryImagesResponse]);

    const handleUpdate = () => {
        const formData = editEventGalleryRef.current.getFormData();
        if (!formData) {
            return error("Please fill all mandatory fields.", "");
        }
        const request = {
            GalleryEventId: eventGalleryByIdResponse?.galleryEventId || 0,
            EventName: formData?.eventName || null,
            EventDate: formData?.eventDate || null,
            EventType: formData?.eventType?.value || formData?.eventType,
            // EventTopicId: formData?.eventTopic?.value || formData?.eventTopic,
            EventTopicId: formData?.eventTopic?.value || formData?.eventTopic?.value || formData?.eventTopic.join(', '),
            IsPublish: formData?.isPublished,
            IsPrivate: formData?.isPrivate,
            UpdatedBy: audit.adminUserId,
            UpdatedAppId: audit.appId,
        }
        updateEventGalleryDetails(request)
    }

    useEffect(() => {
        if (isSuccessDeleteImageByeventGallaryId && DeleteImageByeventGallaryIdResponse) {
            if (DeleteImageByeventGallaryIdResponse?.hasError === false) {
                success("Image Deleted Successfully");
                setGalleryEventImageList((prevImages) =>
                    prevImages.filter((image) => image.GalleryEventImageId !== deletedImageId)
                );
            }
            else {
                error(DeleteImageByeventGallaryIdResponse.errorMessage)
            }
        }
    }, [isSuccessDeleteImageByeventGallaryId, DeleteImageByeventGallaryIdResponse]);

    const handleDelete = ( imageId ) =>{
        confirm('Delete?', 'Are you sure you want to Delete?', 'Delete', 'Cancel').then((confirmed) => {
            if (confirmed) {
                setDeletedImageId(imageId);
                const request = {
                        id: imageId,
                        deletedBy: 115,
                        appId: 1
                    }
                deleteEventGalleryById(request);
            }
        });
    }
    // On handle back click method
    const handleBack = () => { navigate('/EventsGalleryList') }



    const handleFileChange = async (file) => {
        if (!file) return;
        const fileName = file.fileName;
        try {
            const base64Data = file?.base64Data;
            // Call API to store image
            await handleImageUpload({ fileName, base64Data });
        } catch (error) {
            console.error("Error processing image:", error);
        }
    };

    // API Call: Save Image and Update Gallery
    const handleImageUpload = async ({ fileName, base64Data }) => {
        const updateFileRequest = {
            GalleryEventId: parseInt(id),
            ImageEncriptedName: "Images\\EventGalleryImage",
            FileName: fileName,
            StoragePath: "EventGalleryImage",
            base64Data: base64Data,
        };
        await uploadImage(updateFileRequest);
    };

    const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
        if (dataFieldName === "gallaryImage") {
            handleFileChange(updateFormData?.gallaryImage);
        }
    }

    return (<>
        <div className='row'>
            {viewEventListDropDownData && eventGalleryByIdResponse ?
                <FormCreator
                    ref={editEventGalleryRef}
                    config={Editform}
                /> : <DataLoader />
            }
            <div className="">
                <Buttons
                    onClick={() => handleUpdate()}
                    buttonText={"Save"}
                    buttonTypeClassName="theme-btn btn mt-auto"
                    isLoading={false}
                />
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="d-flex fs-3 mt-3">
                        <Label labelName="Gallery Images" />
                    </div>
                </div>
                <div className="col-lg-12 d-flex justify-content-end">
                    <FormCreator
                        ref={uploadImgRef}
                        config={EditUploadImageform}
                        onColumnChange={memoizedHandleFieldChange}
                    />
                </div>
                {isLoadinggetEventGalleryImages ? (
                    <DataLoader />
                ) : (
                    <div className="container mt-3">
                        <div className="row">
                            {galleryEventImageList &&
                                galleryEventImageList.map((item, index) => (
                                    <div
                                        key={index}
                                        className="col-lg-4 col-md-6 col-sm-12 mb-3"
                                        style={{ position: "relative", display: "flex", justifyContent: "center" }}
                                    >
                                        <img
                                            src={item.imageEncriptedName}
                                            alt="Gallery Image"
                                            style={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                height: "250px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                            }}
                                        />
                                        <button
                                            className="delete-icon-button"
                                            onClick={() => handleDelete(item.GalleryEventImageId)}
                                        >
                                            <Iconify
                                                icon="fluent:delete-16-filled"
                                                altText="Logout Icon"
                                                className="user-icon"
                                            />
                                        </button>
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    </>)
}
export default EditEventGalleryForm;